import { ALERT_SUCCESS_THEME } from '@dragonfruit/constants/alertBannerThemes';

export const types = {
  SHOW_ALERT_BANNER: 'SHOW_ALERT_BANNER',
  HIDE_ALERT_BANNER: 'HIDE_ALERT_BANNER',
};

export const showAlertBanner = ({
  theme,
  message = '',
  keepAlive = false,
}) => ({
  type: types.SHOW_ALERT_BANNER,
  payload: {
    theme,
    message,
    keepAlive,
  },
});

export const hideAlertBanner = () => ({ type: types.HIDE_ALERT_BANNER });

const INIT_STATE = {
  showAlertBanner: false,
  message: '',
  theme: ALERT_SUCCESS_THEME,
  keepAlive: false,
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case types.SHOW_ALERT_BANNER:
      const { theme, message, keepAlive } = action.payload;

      return {
        ...state,
        theme,
        message,
        showAlertBanner: true,
        keepAlive,
      };
    case types.HIDE_ALERT_BANNER:
      return {
        ...state,
        ...INIT_STATE,
      };
    default:
      return state;
  }
};

export default reducer;

export const getAlertMessage = state => state.alertBanner.message;
export const getAlertBannerStatus = state => state.alertBanner.showAlertBanner;
export const getAlertTheme = state => state.alertBanner.theme;
export const getIsBannerAlive = state => state.alertBanner.keepAlive;



// WEBPACK FOOTER //
// ./app/redux/alertBanner.js